/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { ImageProps } from "next/image";

export type NextImageType = ImageProps;
export type CosmosImageType = NextImageType;
export type CosmosImageReactElementType = React.ComponentType<NextImageType>;

export const DefaultImage = ({
	//ignore some next-image props
	loader: _loader,
	fetchPriority: _fetchPriority,
	unoptimized: _unoptimized,
	...rest
}: NextImageType): React.JSX.Element => {
	return <img {...rest} src={(rest.src as string) || ""} alt={rest.alt || ""} />;
};
